import { MarkdownShortcutPlugin } from '@lexical/react/LexicalMarkdownShortcutPlugin';

import { TRANSFORMERS } from '@lexical/markdown';

export const ShortcutPlugin = () => {
  return <MarkdownShortcutPlugin transformers={TRANSFORMERS} />;
};
